// extracted by mini-css-extract-plugin
export default {"container":"_1OCCzCcheV5ltSDNN6EuNx"};